﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { IWordTextField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.WordTextField, eOutputFieldType.wordText)
export class WordTextField extends OutputField implements IWordTextField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }
    public deleted: boolean;
    public value: string;
}
